export const SHOW_EVENT = 'httpLoader:show';
export const HIDE_EVENT = 'httpLoader:hide';

/**
 * Intercept http calls and record number of active connections, when number raises over 0 trigger a show event
 * when number goes back to 0 trigger a hide event
 * @param $q
 * @param LoaderService
 * @returns {{request: (function(*=)), response: (function(*=)), responseError: (function(*=))}}
 */
export default function loaderInterceptor($q, $rootScope) {
  'ngInject';
  let numLoadings = 0;
  return {
    request: (config) => {
      numLoadings++;
      $rootScope.$broadcast(SHOW_EVENT);
      return config || $q.when(config);
    },
    response: (response) => {
      if (0 == --numLoadings) $rootScope.$broadcast(HIDE_EVENT);
      return response || $q.when(response);
    },
    responseError: (response) => {
      if (0 == --numLoadings) $rootScope.$broadcast(HIDE_EVENT);
      return $q.reject(response);
    }
  }
}


// WEBPACK FOOTER //
// ./client/app/components/loaderScreen/loader_interceptor.js